module.exports = __webpack_public_path__ + "static/media/twitter.076847f0.svg";